import { styled } from '@mui/system'
import { fontSizes, colors } from '../../Components/consts'

export const InnerCon = styled('div')(({ theme }) => ({
  minHeight: '90vh',
  '& .header': {
    fontSize: fontSizes.xlarge,
    margin: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.large,
      margin: theme.spacing(3, 0),
    },
  },
  '& .standingsCon': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& .footerInfo': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginBottom: theme.spacing(3),
      '& p': {
        fontSize: 12,
        margin: theme.spacing(0.2, 1),
      },
    },
  },
  '& .predictionsCon': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(3, 0, 6),
    '& .titleCon': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& .betaTag': {
        background: colors.green,
        padding: theme.spacing(0, 1),
        color: colors.offWhite,
        fontWeight: 800,
        fontSize: fontSizes.small,
        borderRadius: 8,
        margin: theme.spacing(1, 0.5, 0),
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
          fontWeight: 600,
          margin: theme.spacing(0, 0.25),
          padding: theme.spacing(0, 1),
        },
      },
    },
    '& .predictionTable': {
      width: '100%',
      overflowX: 'scroll',
    },
  },
}))